<script>
  import {Pie} from 'vue-chartjs'

  export default {
    props: ['labels', 'data', 'backgroundColor'],
    extends: Pie,
    name: "pie-chart",
    mounted () {
      // Overwriting base render method with actual data.
      this.renderChart({
        labels: this.labels,
        datasets: [
          {
            data: this.data,
            backgroundColor: this.backgroundColor ? this.backgroundColor :[
              'rgb(121, 185, 248)',
              'rgb(52, 168, 83)',
            ],
          }
        ]
      }, {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          position: 'bottom'
        }
      })
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/charts/PieChart.vue